export default {
    "welcomeMessage": "Utiliza los filtros para mostrar <0>{{nameCollection}}</0>.",
    "noDataMessage": "No hay <0>{{nameCollection}}</0> para mostrar segun los filtros aplicados."
}